module.exports = __webpack_public_path__ + "fonts/d016ba185b6e1aad49d937830a0446e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/AlternativeDatePicker/image/calendar_white.svg
// module id = 2038
// module chunks = 0